<template>
  <div>
    <div
      v-for="(item, index) in value"
      :key="item.id || index"
      class="flex items-center gap-[8px] mb-[8px]"
    >
      <infinite-select
        v-model="value[index]"
        placeholder="Pilih Bahan Packing"
        class="flex-1 bg-white min-w-0 packing-infinite-select flex-0"
        option-label="name"
        :default-value="item"
        :options="getMaterialOptions(item)"
        :has-next-page="fetcher && fetcher.hasMore ? fetcher.hasMore : false"
        :debounce-timeout="500"
        :loading="fetcher && fetcher.loading ? fetcher.loading : false"
        :clearable="false"
        :reduce="reducePackingMaterial"
        :disabled="disabled"
        append-to-body
        :calculate-position="positionDropdown"
        @on-search="handleSearchPacking"
        @on-intersect="handleIntersect"
        @input="onInput"
      >
        <template #no-options="{ search, searching }">
          <template v-if="searching">
            Bahan packing untuk <em>'{{ search }}'</em> tidak ditemukan.
          </template>
          <em v-else>Masukan bahan packing yang valid</em>
        </template>
      </infinite-select>
      <SpinnerInput
        v-model="item.layer"
        class="w-[80px]"
        :disabled="disabled"
        :min="1"
        @input="$emit('input', value)"
      />
      <UiButton
        type="icon"
        class="!w-[32px] !h-[32px] hover:!bg-[#FEE2E2]"
        aria-label="Hapus bahan packing"
        :disabled="disabled"
        @click="removeItem(index)"
      >
        <span class="k-trash text-[#E31A1A] text-[16px]" />
      </UiButton>
    </div>
  </div>
</template>

<script>
import { SpinnerInput, Button } from '@core/components/ui'
import InfiniteSelect from '@/views/components/select/InfiniteSelect.vue'

export default {
  name: 'PackingSelection',
  components: {
    SpinnerInput,
    UiButton: Button,
    InfiniteSelect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fetcher: {
      type: Object,
      required: false,
      default: () => ({
        data: [],
        hasMore: false,
        loading: false,
      }),
    },
  },
  data() {
    return {
      packingOptions: [],
    }
  },
  watch: {
    'fetcher.data': {
      handler(newData) {
        if (newData) {
          this.packingOptions = newData
        }
      },
      immediate: true,
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.value)
    },
    removeItem(index) {
      const newValue = [...this.value]
      newValue.splice(index, 1)
      this.$emit('input', newValue)
    },
    getMaterialOptions(currentPacking) {
      return this.packingOptions.map(val => ({
        ...val,
        disabled: this.value.some(selected => selected.id === val.id && selected.id !== currentPacking.id),
      })) || []
    },
    async handleSearchPacking(search) {
      if (!search) {
        this.packingOptions = this.fetcher.data || []
        return
      }
      const searchResults = (this.fetcher.data || []).filter(val => val.name.toLowerCase().includes(search.toLowerCase()))
      if (searchResults.length === 0 && this.fetcher?.hasMore && this.fetcher?.fetchData) {
        const prevLength = (this.fetcher.data || []).length
        await this.fetcher.fetchData()
        const newLength = (this.fetcher.data || []).length
        if (newLength > prevLength) {
          this.handleSearchPacking(search)
          return
        }
      }
      this.packingOptions = searchResults
    },
    handleIntersect() {
      if (this.fetcher && this.fetcher.fetchData) {
        this.fetcher.fetchData()
      }
    },
    reducePackingMaterial(val) {
      return {
        name: val.name,
        layer: val.layer || 1,
        id: val.id,
      }
    },
    positionDropdown(dropdownList, component, { width }) {
      const dropdownEl = dropdownList
      dropdownEl.style.width = width
      const {
        top,
        left,
        height,
      } = component.$el.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      dropdownEl.style.left = `${left}px`
      dropdownEl.style.top = `${top + height + scrollTop}px`
    },
  },
}
</script>

<style lang="scss">
.packing-infinite-select {
  .vs__dropdown-toggle {
    border-color: #E5E5E5 !important;
    border-radius: 10px !important;
    padding: 0 !important;
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
  }
  .vs__selected-options {
    padding: 0 12px !important;
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
    flex-wrap: nowrap !important;
    position: relative !important;
    width: 100% !important;
    overflow: hidden !important;
  }
  .vs__selected {
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    left: 12px !important;
    right: 12px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    font-size: 14px !important;
    color: #0A0A0A !important;
    pointer-events: none !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .vs__search, .vs__search:focus {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 14px !important;
    height: 100% !important;
    width: 100% !important;
    border: none !important;
    box-shadow: none !important;
    line-height: normal !important;
  }
  .vs__actions {
    padding: 0 8px 0 0 !important;
    display: flex !important;
    align-items: center !important;
  }
}
</style>
